/* @flow */
import React from 'react';

import ButtonTemplate from 'components/UIKit/Button/ButtonTemplate';
import ReleasedIcon from 'components/icons/ReleasedIcon';
import { Spinner } from 'components/UIKit/Spinner';
import { Tooltip } from 'components/UIKit/Tooltip';
import { setModal } from 'ducks/modal';
import Release from 'components/Release';

export default function ReleaseButton({handleOnClick, style, disabled, children, isFetching, dispatch, projectInfo, ...props}: Object): React.Element {
  let program = projectInfo.programs[0].name;
  return (
    <ButtonTemplate
      style={style}
      disabled={disabled}
      onClick={() => dispatch(setModal({
        Component: () => <Release
          project={projectInfo.code}
          program={program}
          disabled={disabled}
          closeModal={() => dispatch(setModal({Component: null}))}
          handleOnClick={handleOnClick}
          dispatch={dispatch}
        />,
        style: {
          content: {
            position: 'initial',
            bottom: 'auto',
            right: 'auto',
            left: 'auto',
            top: 'auto',
            width: '60rem'
          }
        }
      }))}
      // onClick={handleOnClick}
      PrefixComponent={
        isFetching ? <Spinner style={{width: '14px', height: '14px', margin: '0 0.25rem'}}/> : <ReleasedIcon style={{margin: '0 .25rem'}}/>
      }>
      {disabled &&
        <Tooltip Component={'This project is not releasable'}>
          {children || 'Request Release'}
        </Tooltip>
      }
      {!disabled &&
        <span>{children || 'Request Release'}</span>
      }
    </ButtonTemplate>
  );
}
